import { usePhoneLayout } from "../lib/PhoneLayout";
import { motion, useReducedMotion } from "framer-motion";
import WordReveal, { useReducedData } from "./WordReveal";

export function Reveal({ children, delay = 0, y = 24, className = "" }) {
  const phone = usePhoneLayout();
  const reduced = useReducedMotion();
  const reducedData = useReducedData();
  if (phone || reduced || reducedData) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHead({ eyebrow, title, sub, align = "center", dark = false, size = "lg", testId }) {
  const phone = usePhoneLayout();
  const sizes = {
    lg: phone ? "text-3xl sm:text-4xl lg:text-5xl" : "text-4xl sm:text-5xl lg:text-[64px]",
    md: "text-3xl sm:text-4xl lg:text-5xl",
  };
  return (
    <div className={align === "center" ? "text-center" : ""} data-testid={testId}>
      {eyebrow && <p className={`eyebrow mb-4 ${dark ? "text-white/50" : ""}`}>{eyebrow}</p>}
      <WordReveal text={title} dark={dark} className={`h-display ${sizes[size]} text-balance`} />
      {sub && (
        <p
          className={`mt-5 max-w-lg ${phone ? "text-base" : "text-[13px] sm:text-[14px]"} leading-relaxed ${dark ? "text-white/70" : "text-charcoal/80"}`}
          style={align === "center" ? { marginInline: "auto" } : {}}
        >
          {sub}
        </p>
      )}
    </div>
  );
}
